import React from 'react';
import { ChildProps } from 'react-apollo';
import gql from 'graphql-tag';

import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import {
  CoreMyListingsSellerListingCards,
  reverb_search_SearchResponse,
} from '@reverbdotcom/commons/src/rql';

import SellerListingCard from './SellerListingCard';
import LoadingOverlay from '../../shared/loading_overlay';
import PlaceholderSellerListingCard from './PlaceholderSellerListingCard';

interface IExternalProps {
  listingIds: string[] | number[];
}

type IProps = ChildProps<IExternalProps, CoreMyListingsSellerListingCards.Query>;

export function SellerListingCardsCollection({ data, listingIds }: IProps) {
  const { loading, me = {} } = data;
  const { shop = {} } = me;
  const { listings: listingsResponse } = shop;
  const {
    listings = [],
  }: reverb_search_SearchResponse = listingsResponse ?? {};

  const placeholderListings = Array.from(Array(listingIds.length).keys());
  const shouldRenderPlaceholderListings = loading;

  return (
    <LoadingOverlay showOverlay={loading}>
      {shouldRenderPlaceholderListings ? placeholderListings.map(element => (
        <div key={`placeholderListing-${element}`} className="pb-2">
          <PlaceholderSellerListingCard />
        </div>
      )) : listings.map(listing => (
        <div key={listing.id} className="pb-2">
          <SellerListingCard listing={listing} />
        </div>
      ))}
    </LoadingOverlay>
  );
}

export const SellerListingCardFragment = gql`
  fragment SellerListingCard on Listing {
    _id
    id
    sellerUuid
    title
    slug
    sku
    state
    inventory
    condition {
      displayName
    }
    sellerPrice {
      amount
      amountCents
      symbol
      currency
      display
    }
    images(input: { transform: "card_square", count: 1 }) {
      source
    }
    counts {
      views
      offers
      watchers
    }
    publishedAt {
      seconds
    }
    hasInventory
    orders {
      nodes {
        _id
      }
    }
  }
`;

const withQuery = withGraphql<IExternalProps, CoreMyListingsSellerListingCards.Query>(
  gql`
    query Core_MyListings_SellerListingCards($listingIds: [String]) {
      me {
        uuid
        shop {
          _id
          listings(input: { ids: $listingIds }) {
            listings {
              _id
              ...SellerListingCard
            }
          }
        }
      }
    },
    ${SellerListingCardFragment}
  `,
  {
    options: ({ listingIds }) => {
      return {
        ssr: false,
        variables: {
          listingIds,
        },
        errorPolicy: 'all',
      };
    },
  },
);

export default withQuery(SellerListingCardsCollection);
